export const DNI_VALUE = '1';
export const CE_VALUE = '3';
export const MASCULINO_VALUE = '1';
export const FEMININO_VALUE = '2';
export const STATUS_IDLE = 'idle';
export const MONEDA = {
  PEN: 'S',
};

export const STATUS = {
  FAILED: 'failed',
  LOADED: 'loading',
  SUCCEEDED: 'succeeded',
};
